import React, { Component, useRef } from "react";
import { makeStyles, withStyles, useTheme } from '@material-ui/core/styles';
import Save from '../../../../assets/img/svg/save.svg';
import Cancel from '../../../../assets/img/svg/cancel.svg';
import { TextField, InputBase, Checkbox, InputAdornment, IconButton, Select, MenuItem, FormControl, FormHelperText, Radio, RadioGroup, FormControlLabel } from '@material-ui/core';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import desc from '../../../../assets/img/svg/desc.svg';
import { useNavigate } from "react-router-dom";
import image from "../../../../assets/img/svg/Image.svg"
import Autocomplete from "react-autocomplete";
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import styles from "../../../../assets/jss/customStyle";
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import $ from "jquery"
import axios from "axios";
import API from "../../../../_helpers/endpointService";
import moment from "moment";
import Delete from '../../../../assets/img/svg/delete.svg';
import del from "../../../../assets/img/svg/Del.svg"
import { getlookupdocinfo } from "../../../../actions/MasterDataAction";
import { ContactlessOutlined } from "@material-ui/icons";
import deactive from '../../../../assets/img/svg/deactive.svg';

const useStyles = makeStyles((theme) => ({
    chips: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    chip: {
        margin: 2,
    },
    error: {
        color: '#f44336',
    },
    helperText: {
        '& p': {
            marginLeft: "0px !important"
        }
    },
    button: {
        background: "#FFFFFF",
        border: "none",
        boxSizing: "border-box",
        borderRadius: "7px",
    },
}));

const BootstrapError = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 0,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #f44336',
        fontSize: 16,
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
    },
}))(InputBase);

const BootstrapInput = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 0,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #ced4da',
        fontSize: 16,
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
    },
}))(InputBase);

const names = [
    'Oliver Hansen',
    'Van Henry',
    'April Tucker',
    'Ralph Hubbard',
];

function getStyles(name, personName, theme) {
    return {
        fontWeight:
            personName.indexOf(name) === -1
                ? theme.typography.fontWeightRegular
                : theme.typography.fontWeightMedium,
    };
}

const CheckboxWithBlackCheck = withStyles({
    root: {
        "& .MuiSvgIcon-root": {
            fill: "#FFFFFF",
            width: 20,
            height: 20,
            border: "1px solid #000000",
            "&:hover": {
                backgroundColor: "#FFFFFF"
            }
        },
        "&$checked": {
            "& .MuiIconButton-label": {
                position: "relative",
                zIndex: 0,
                backgroundColor: "#FFFFFF",
            },
            "& .MuiIconButton-label:after": {
                content: '""',
                height: 10,
                width: 10,
                position: "absolute",
                backgroundColor: "#000000",
                zIndex: -1
            }
        }
    },
    checked: {}
})(Checkbox);

class AddIADOS extends Component {
    constructor(props) {
        super(props);
        this.inputCPhoto = React.createRef();
        this.inputPhoto = React.createRef();
        this.state = {
            isMobile: false,
            state: {
                checkedA: true,
                checkedB: false,
            },
            isError: false,
            Photos: {},
            CPhotos: [],
            check: false,
            fileUrl: "",
            fileName: "",
            cancel: false,
            ProjectId: 0,
            Error: {
                DateError: false,
                LocationError: false,
                CategoryError: false,
                StatusError: false,
                ObservationError: false,
                CorrectiveActionError: false,
                ResponsibleDepartmentError: false,
                PhotoError: false,
                TargetDateError: false,
                TotalFindingsError: false,
                MajorCloseError: false,
                MinorCloseError: false,
                MinorOpenError: false,
                MajorOpenError: false,
                TotalMajorError: false,
                TotalMinorError: false,
            },
            value1: 0,
            Initial: {
                "Id": 0,
                "ProjectId": 0,
                "TotalFindings": '',
                "FindingsClosed": '',
                "FindingsOpen": '',
                "MajorClose": '',
                "MinorClose": '',
                "MinorOpen": '',
                "MajorOpen": '',
                "TotalMajor": '',
                "TotalMinor": '',
                "Modify": ''
            },
            addData: {
                "Id": 0,
                "ProjectId": 0,
                "Location": "",
                "Status": "",
                "Category": "",
                "Observation": "",
                "CorrectiveAction": "",
                "ResponsibleDepartment": "",
                "CompletionDate": null,
                "TargetDate": "",
                "Date": "",
                "ModifiedBy": ""
            }
        }
    }

    componentDidMount() {
        this.state.addData.ModifiedBy = localStorage.getItem("UserRoles");
        this.state.Initial.Modify = localStorage.getItem("UserRoles");
        this.state.addData.ProjectId = parseInt(localStorage.getItem("DashId"));
        this.state.ProjectId = localStorage.getItem("DashId");
        this.state.UserRole = localStorage.getItem("UserRoles");
        this.state.value1 = localStorage.getItem("InitialAuditValue")
        this.state.Initial.ProjectId = parseInt(localStorage.getItem("DashId"));
        this.setState({})
        this.props.dispatch(getlookupdocinfo("DailyObservation"))
        window.addEventListener("resize", this.resize.bind(this));
        this.resize()
        this.interval = setInterval(() => {
            this.resize1()
        }, 10);
    }
    componentWillUnmount() {
        clearInterval(this.interval);
        window.removeEventListener("resize", this.resize.bind(this));
        $("#INIT1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Initial1 .MuiListItemText-primary").removeClass("fw-bolder");
        $("#Initial").addClass("d-none");
        $("#Initial").removeClass("d-block");
        $("#IADOSL").removeClass("active-color");
        $("#IADOST").removeClass("fw-bolder");
    }

    AttachFiles = (e) => {
        this.state.cancel = true
        this.props.dispatch({ type: "CANCEL", data: true });

        this.inputCPhoto.current.click();
    };
    AttachFiles1 = (e) => {
        this.state.cancel = true
        this.props.dispatch({ type: "CANCEL", data: true });

        this.inputPhoto.current.click();
    };
    handleInputChange = (e, node) => {
        this.state.cancel = true
        this.props.dispatch({ type: "CANCEL", data: true });

        if (node === "Observation") {
            if (e.target.value.length - 1 < 500) {
                this.state.addData.Observation = e.target.value;
            }
        } else if (node === "CorrectiveAction") {
            if (e.target.value.length - 1 < 500) {
                this.state.addData.CorrectiveAction = e.target.value;
            }
        } else if (node === "ResponsibleDepartment") {
            if (e.target.value.length - 1 < 500) {
                this.state.addData.ResponsibleDepartment = e.target.value;
            }
        } else {
            this.state.addData[node] = e.target.value;
        }
        this.setState({});
    };
    handleDateChange = (e, node) => {
        this.state.cancel = true
        this.props.dispatch({ type: "CANCEL", data: true });

        if (node === "CompletionDate") {
            if (e.target.value === "") {
                this.state.addData[node] = null
                this.setState({});
            }
            else {
                this.state.addData[node] = e.target.value
                this.setState({});
            }
        }
        else {
            this.state.addData[node] = e.target.value
            this.setState({});
        }
    };
    handleNumberChange = (e, node) => {
        this.state.cancel = true
        this.props.dispatch({ type: "CANCEL", data: true });

        if (e.target.value == '') {
            this.state.Initial[node] = ''
            this.setState({});
        }
        else {
            this.state.Initial[node] = parseInt(e.target.value)
            this.setState({});
        }
        if (this.state.Initial.MajorClose != '' && this.state.Initial.MinorClose != '') {
            this.state.Initial.NoofFindingsClose = this.state.Initial.MajorClose + this.state.Initial.MinorClose
            this.setState({})
        }
        else if (this.state.Initial.MajorClose != '') {
            this.state.Initial.NoofFindingsClose = this.state.Initial.MajorClose
            this.setState({})
        }
        else {
            this.state.Initial.NoofFindingsClose = this.state.Initial.MinorClose
            this.setState({})
        }
        if (this.state.Initial.TotalMajor != '' && this.state.Initial.MajorClose != '') {
            this.state.Initial.MajorOpen = this.state.Initial.TotalMajor - this.state.Initial.MajorClose
            this.setState({})
        }
        else if (this.state.Initial.TotalMajor != '') {
            this.state.Initial.MajorOpen = this.state.Initial.TotalMajor
            this.setState({})
        }
        else {
            this.state.Initial.MajorOpen = this.state.Initial.MajorClose
            this.setState({})
        }
        if (this.state.Initial.TotalMinor != '' && this.state.Initial.MinorClose != '') {
            this.state.Initial.MinorOpen = this.state.Initial.TotalMinor - this.state.Initial.MinorClose
            this.setState({})
        }
        else if (this.state.Initial.TotalMinor != '') {
            this.state.Initial.MinorOpen = this.state.Initial.TotalMinor
            this.setState({})
        }
        else {
            this.state.Initial.MinorOpen = this.state.Initial.MinorClose
            this.setState({})
        }
        if (this.state.Initial.MajorOpen != '' && this.state.Initial.MinorOpen != '') {
            this.state.Initial.NoofFindingsOpen = this.state.Initial.MajorOpen + this.state.Initial.MinorOpen;
            this.setState({})
        }
        else if (this.state.Initial.MajorOpen != '') {
            this.state.Initial.NoofFindingsOpen = this.state.Initial.MajorOpen
            this.setState({})
        }
        else {
            this.state.Initial.NoofFindingsOpen = this.state.Initial.MinorOpen
            this.setState({})
        }
    }
    handleRadio = (event) => {
        this.props.dispatch({ type: "CANCEL", data: true });

        this.state.cancel = true
        this.state.radio = event.target.value
        this.setState({})
    };
    sidebar = () => {
        if (this.state.cancel === true) {
            window.$("#cancelpopup1").modal("show");
        }
        else {
            this.props.navigate("/sidebar");
        }

    };
    SideBarCancel = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        window.$("#cancelpopup1").modal("hide");
        this.props.navigate("/sidebar");
    }
    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
        //  $("#INIT1 .MuiListItemText-primary").addClass("spanTopBar");
        // $("#Initial1 .MuiListItemText-primary").addClass("fw-bolder");
        // $("#Initial").removeClass("d-none");
        // $("#Initial").addClass("d-block");
        // $("#IADOSL").addClass("active-color");
        // $("#IADOST").addClass("fw-bolder");
    };
    resize1 = () => {
        $("#INIT1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Initial1 .MuiListItemText-primary").addClass("fw-bolder");
        $("#Initial").removeClass("d-none");
        $("#Initial").addClass("d-block");
        $("#IADOSL").addClass("active-color");
        $("#IADOST").addClass("fw-bolder");
    };
    AddCancel1 = () => {
        if (this.state.cancel === true) {
            window.$("#cancelpopup").modal("show");
        }
        else {
            this.props.dispatch({ type: "CANCEL", data: false });
            this.props.navigate(`/initialauditdailyobservationstatus`)
        }
    }
    AddCancel = () => {
        window.$("#cancelpopup").modal("hide");
        this.props.dispatch({ type: "CANCEL", data: false });
        this.props.navigate("/initialauditdailyobservationstatus")
    };
    AddSave = () => {
        if (this.state.value1 == 1) {
            if (this.state.Initial.TotalFindings === '') {
                this.state.Error.TotalFindingsError = true;
                this.setState({})
            }
            else {
                this.state.Error.TotalFindingsError = false;
                this.setState({})
            }
            if (this.state.Initial.MajorClose == '') {
                this.state.Error.MajorCloseError = true;
                this.setState({})
            }
            else {
                this.state.Error.MajorCloseError = false;
                this.setState({})
            }
            if (this.state.Initial.MinorClose == '') {
                this.state.Error.MinorCloseError = true;
                this.setState({})
            }
            else {
                this.state.Error.MinorCloseError = false;
                this.setState({})
            }
            if (this.state.Initial.TotalMajor === '') {
                this.state.Error.TotalMajorError = true;
                this.setState({})
            }
            else {
                this.state.Error.TotalMajorError = false;
                this.setState({})
            }
            if (this.state.Initial.TotalMinor === '') {
                this.state.Error.TotalMinorError = true;
                this.setState({})
            }
            else {
                this.state.Error.TotalMinorError = false;
                this.setState({})
            }
            if (this.state.Initial.TotalFindings != '' && this.state.Initial.MajorClose != '' && this.state.Initial.MinorClose != '' && this.state.Initial.TotalMajor != '' && this.state.Initial.TotalMinor != '') {
                this.props.dispatch({ type: "CANCEL", data: false });
                this.PostAudit(this.state.Initial)
            }
        }
        else {

            if (this.state.addData.Date == '') {
                this.state.Error.DateError = true;
                this.setState({})
            }
            else {
                this.state.Error.DateError = false;
                this.setState({})
            }
            if (this.state.addData.Location.trim() == '') {
                this.state.Error.LocationError = true;
                this.state.addData.Location = this.state.addData.Location.trim();
                this.setState({})
            }
            else {
                this.state.Error.LocationError = false;
                this.state.addData.Location = this.state.addData.Location.trim();
                this.setState({})
            }
            if (this.state.addData.Status == '') {
                this.state.Error.StatusError = true;
                this.setState({})
            }
            else {
                this.state.Error.StatusError = false;
                this.setState({})
            }
            if (this.state.addData.Category.trim() == '') {
                this.state.Error.CategoryError = true;
                this.state.addData.Category = this.state.addData.Category.trim();
                this.setState({})
            }
            else {
                this.state.Error.CategoryError = false;
                this.state.addData.Category = this.state.addData.Category.trim();
                this.setState({})
            }
            if (this.state.addData.CorrectiveAction.trim() == '') {
                this.state.Error.CorrectiveActionError = true;
                this.state.addData.CorrectiveAction = this.state.addData.CorrectiveAction.trim();
                this.setState({})
            }
            else {
                this.state.Error.CorrectiveActionError = false;
                this.state.addData.CorrectiveAction = this.state.addData.CorrectiveAction.trim();
                this.setState({})
            }
            if (this.state.addData.Observation.trim() == '') {
                this.state.Error.ObservationError = true;
                this.state.addData.Observation = this.state.addData.Observation.trim();
                this.setState({})
            }
            else {
                this.state.Error.ObservationError = false;
                this.state.addData.Observation = this.state.addData.Observation.trim();
                this.setState({})
            }
            if (this.state.addData.ResponsibleDepartment.trim() == '') {
                this.state.Error.ResponsibleDepartmentError = true;
                this.state.addData.ResponsibleDepartment = this.state.addData.ResponsibleDepartment.trim();
                this.setState({})
            }
            else {
                this.state.Error.ResponsibleDepartmentError = false;
                this.state.addData.ResponsibleDepartment = this.state.addData.ResponsibleDepartment.trim();
                this.setState({})
            }
            if (this.state.addData.TargetDate == '') {
                this.state.Error.TargetDateError = true;
                this.setState({})
            }
            else {
                this.state.Error.TargetDateError = false;
                this.setState({})
            }
            if (Object.keys(this.state.Photos).length === 0) {
                this.state.Error.PhotoError = true;
                this.setState({})
            }
            else {
                this.state.Error.PhotoError = false;
                this.setState({})
            }
            let formData = new FormData()
            formData.append("photo", this.state.Photos.fdata)
            Array.from(this.state.CPhotos).forEach(async (a) => {
                formData.append("completionPhoto", a.fdata)
            })
            if (this.state.addData.Date != '' && this.state.addData.Location != '' && this.state.addData.Status != '' && this.state.addData.Category != '' && this.state.addData.CorrectiveAction != '' && this.state.addData.Observation != '' && this.state.addData.ResponsibleDepartment != '' && this.state.addData.TargetDate != "" && this.state.Error.PhotoError == false) {
                this.props.dispatch({ type: "CANCEL", data: false });

                this.addiadosdocinfo(this.state.addData, formData)
            }
        }
    }
    PostAudit = (data) => {
        let apiUrl = API.INITIAL_AUDIT;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "POST",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.props.navigate("/initialauditdailyobservationstatus")
                } else {

                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })

                if (error?.response?.status === 401) {
                }
            });
    }
    addiadosdocinfo = (data, formData) => {
        let apiUrl = API.IADOS_LISTVIEW;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "POST",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.adduploadiadosdocinfo(formData, response.data)
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                }
            });
    };
    adduploadiadosdocinfo = (data, id) => {
        let apiUrl = API.IADOS_LISTVIEW + '/' + id;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "POST",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.props.navigate("/initialauditdailyobservationstatus")
                } else {

                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })

                if (error?.response?.status === 401) {
                }
            });
    };
    UploadFile = (e) => {
        Array.from(e.target.files).forEach(async (a) => {
            let upload = {
                FileName: a.name,
                Filesize: a.size,
                fdata: a,
                base64: await this.toBase64(a),
                check: false,
            }
            this.state.Photos = upload
            this.setState({})
        })


    };
    UploadFile1 = (e) => {
        Array.from(e.target.files).forEach(async (a) => {
            let upload = {
                FileName: a.name,
                Filesize: a.size,
                check: false,
                fdata: a,
                base64: await this.toBase64(a),
            }
            this.state.CPhotos.push(upload)
            this.setState({})
        })
    }
    toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
    setCheckbox = (str) => {
        this.state.Photos.check = !this.state.Photos.check;
    };
    setCheckbox1 = (str) => {
        this.state.CPhotos.map((i) => {
            if (str == i.FileName) {
                i.check = !i.check;
                this.setState({});
            }
        })
    };
    OpenPopup1 = (i) => {
        this.state.delindex1 = i;
        this.setState({})
        window.$("#deletepopup1").modal("show");
    }
    OpenPopup = (i) => {
        this.state.delindex = i;
        this.setState({})
        window.$("#deletepopup").modal("show");
    }
    openView = (url, name) => {
        this.state.fileUrl = url;
        this.state.fileName = name;
        this.setState({})
        window.$('#viewscreen').modal('show')
    }
    DeleteItem1 = () => {
        let tempData = [];
        this.state.CPhotos.map((i, a) => {
            if (a != this.state.delindex1) {
                tempData.push(i)
            }
        })
        this.state.CPhotos = tempData;
        this.setState({})
        window.$("#deletepopup1").modal("hide");
    }
    DeleteItem = () => {
        this.state.Photos = {};
        this.setState({})
        window.$("#deletepopup").modal("hide");
    }
    renderProjectNames = (state, val) => {
        return state?.Name?.toLowerCase().indexOf(val?.toLowerCase()) !== -1;
    };
    handleProjectNameSelectChange = (e) => {
        this.state.addData.Location = e;
        this.setState({});
    };
    handleProjectNameSearchChange = (e) => {
        this.state.addData.Location = e.target.value;
        this.setState({});
    };

    render() {
        let { classes, menuToggle, LocationLookUp } = this.props;
        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row w-100 mt-4">
                                <div className="col-6 mt-auto">
                                    <List className="pt-4 mt-4 pl-3" style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={this.sidebar} >
                                            <ListItemText id={"INIT" + "1"} className='  textNaviIcon' primary="Daily Tasks" />
                                            <NavigateNextIcon id="INIT" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                            <Divider className='border-bottom' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-6 pt-3 mt-5">
                                    <h4>{this.state.value1 == 0 ? "Add New Observation Status" : "Add Initial Audit "} </h4>
                                </div>
                            </div>
                        </>
                        :
                        <></>
                }
                <div className="ml-auto scroll-hide" style={{ backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -95 }}>
                    {this.state.isMobile ? <table className="dataTable border-top" width="100%">
                        <tbody>
                            <tr>
                                <td className="border-right text-center">
                                    <i class="fa fa-arrow-left cursorPointer" onClick={this.AddCancel1}></i></td>
                                <td className="border-right text-center">
                                    <button className={classes.button} onClick={this.AddSave}><img src={Save} style={{ marginTop: '-4px' }}></img>&nbsp;Save</button>
                                </td>
                                <td className="text-center">
                                    <button className={`${classes.button} pl-3`} onClick={this.AddCancel1}><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                        :
                        <table className="dataTable" width="100%">
                            <tbody>
                                <tr>
                                    <td width="5%" className="border-right text-center"><i class="fa fa-arrow-left cursorPointer" onClick={this.AddCancel1}></i></td>
                                    <td width="95%">
                                        <button className={classes.button} onClick={this.AddSave}><img src={Save} style={{ marginTop: '-4px' }}></img>&nbsp;Save</button>
                                        <button className={`${classes.button} pl-3`} onClick={this.AddCancel1}><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>}
                    <div style={{ margin: this.state.isMobile ? "" : "5px" }}>
                        {this.state.isMobile ? "" :
                            <h6 className="col-12 mx-2 mt-3 ml-1">{this.state.value1 == 0 ? "Add New Observation Status" : "Add Initial Audit"}</h6>}
                        <div className={this.state.isMobile ? "row mt-1 mx-0 pr-2 pt-1" : "row mt-1 mx-3 pr-2 pt-1"}>
                            {this.state.value1 == 0 ? <>
                                <div className={`row mt-2 mx-1 align-items-center ${this.state.isMobile ? "" : "text-row"}`}>
                                    <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right border-top col-md-12" : "col-md-2  px-0 "}`}>
                                        <label className={this.state.isMobile ? "d-flex mt-2" : "m-0 d-flex float-end text-right"}>Date&nbsp;:
                                            <div className={`${classes.helperText}`}>
                                                <div className="MuiFormHelperText-contained">*</div>
                                            </div></label>
                                    </div>
                                    <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                        {this.state.Error.DateError ?
                                            <TextField
                                                variant="outlined"
                                                size="small"
                                                fullWidth
                                                error
                                                value={this.state.addData.Date && moment(this.state.addData.Date).format("yyyy-MM-DD")}
                                                inputProps={{
                                                    max: `${JSON.parse(localStorage.getItem('BasicInfo')) && (JSON.parse(localStorage.getItem('BasicInfo')).Status.toLowerCase() == 'completed' ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectCompletionDate).format("yyyy-MM-DD") : JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate != null ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate).format("yyyy-MM-DD") : moment(JSON.parse(localStorage.getItem('BasicInfo')).EstimatedCompletionDate).format("yyyy-MM-DD"))}`,
                                                    min: `${JSON.parse(localStorage.getItem('BasicInfo')) && moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectStartDate).format("yyyy-MM-DD")}`,
                                                  }}
                                                placeholder={this.state.addData.Date && moment(this.state.addData.Date).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                                onChange={(e) => { this.handleDateChange(e, "Date") }}
                                                type="date"
                                                id="type-date"
                                                InputProps={{
                                                    className: `border-radius  ${classes.inputfieldAlign}`
                                                }}

                                            /> : <TextField
                                                variant="outlined"
                                                size="small"
                                                fullWidth
                                                type="date"
                                                id="type-date"
                                                value={this.state.addData.Date && moment(this.state.addData.Date).format("yyyy-MM-DD")}
                                                inputProps={{
                                                    max: `${JSON.parse(localStorage.getItem('BasicInfo')) && (JSON.parse(localStorage.getItem('BasicInfo')).Status.toLowerCase() == 'completed' ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectCompletionDate).format("yyyy-MM-DD") : JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate != null ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate).format("yyyy-MM-DD") : moment(JSON.parse(localStorage.getItem('BasicInfo')).EstimatedCompletionDate).format("yyyy-MM-DD"))}`,
                                                    min: `${JSON.parse(localStorage.getItem('BasicInfo')) && moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectStartDate).format("yyyy-MM-DD")}`,
                                                  }}
                                                placeholder={this.state.addData.Date && moment(this.state.addData.Date).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                                onChange={(e) => { this.handleDateChange(e, "Date") }}

                                                InputProps={{
                                                    className: `border-radius  ${classes.inputfieldAlign}`
                                                }}
                                            />
                                        }
                                    </div>
                                    <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  px-0 "}`}>
                                        <label className={this.state.isMobile ? "d-flex mt-2" : "m-0 d-flex float-end text-right"}>Location&nbsp;:
                                            <div className={`${classes.helperText}`}>
                                                <div className="MuiFormHelperText-contained">*</div>
                                            </div></label>
                                    </div>
                                    <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                        {this.state.Error.LocationError ?
                                            <div className="autocomplete-wrappers">
                                                <Autocomplete
                                                    contentEditable={true}
                                                    value={this.state.addData.Location}
                                                    inputProps={{
                                                        placeholder: "Location",
                                                    }}
                                                    items={LocationLookUp ?? []}
                                                    getItemValue={(item) => item.Name}
                                                    shouldItemRender={this.renderProjectNames.bind(this)}
                                                    renderMenu={(item) => (
                                                        <div className="dropdowns d-block" >{item}</div>
                                                    )}
                                                    renderInput={(props) => {
                                                        return (
                                                            <input
                                                                className="form-control border-radius"
                                                                id="exampleFormControlInput1"
                                                                {...props}
                                                                style={{ width: '100%', height: 32, fontSize: 12, color: "#000000", borderColor: 'red' }}
                                                            />
                                                        );
                                                    }}
                                                    renderItem={(item, isHighlighted) => (
                                                        <div
                                                            className={`items 
                                                                            ${isHighlighted ? "selected-items" : ""
                                                                }`}
                                                        >
                                                            {item.Name}
                                                        </div>
                                                    )}
                                                    onChange={(e) => this.handleProjectNameSearchChange(e)}
                                                    onSelect={(e) => this.handleProjectNameSelectChange(e)}
                                                />

                                            </div> :
                                            <div className=" autocomplete-wrappers">
                                                <Autocomplete
                                                    contentEditable={true}
                                                    value={this.state.addData.Location}
                                                    inputProps={{
                                                        placeholder: "Location",
                                                    }}

                                                    items={LocationLookUp ?? []}
                                                    getItemValue={(item) => item.Name}
                                                    shouldItemRender={this.renderProjectNames.bind(this)}
                                                    renderMenu={(item) => (
                                                        <div className="dropdowns d-block" >{item}</div>
                                                    )}

                                                    renderInput={(props) => {
                                                        return (
                                                            <input
                                                                className="form-control border-radius"
                                                                id="exampleFormControlInput1"
                                                                {...props}
                                                                style={{ width: '100%', height: 35, fontSize: 12, color: "#000000" }}
                                                            />
                                                        );
                                                    }}
                                                    renderItem={(item, isHighlighted) => (
                                                        <div
                                                            className={`items 
                                                                        ${isHighlighted ? "selected-items" : ""
                                                                }`}
                                                        >
                                                            {item.Name}
                                                        </div>
                                                    )}
                                                    onChange={(e) => this.handleProjectNameSearchChange(e)}
                                                    onSelect={(e) => this.handleProjectNameSelectChange(e)}
                                                />

                                            </div>

                                        }

                                    </div>

                                </div>
                                <div className={`row mx-1 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>

                                    <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  px-0 "}`}>
                                        <label className={this.state.isMobile ? "d-flex mt-2" : "m-0 d-flex float-end text-right"}>Category&nbsp;:
                                            <div className={`${classes.helperText}`}>
                                                <div className="MuiFormHelperText-contained">*</div>
                                            </div></label>
                                    </div>

                                    <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-2" : "col-md-4 pt-4 pb-4"}`}>
                                        {this.state.Error.CategoryError ?
                                            <>
                                                <RadioGroup row value={this.state.addData.Category} onChange={(e) => { this.handleInputChange(e, "Category") }} fullWidth className={classes.error}>
                                                    <FormControlLabel value="Major" control={<Radio color="default" className={classes.error} />} label="Major" size="small" />
                                                    <FormControlLabel value="Minor" control={<Radio color="default" className={classes.error} />} label="Minor" size="small" />
                                                </RadioGroup>
                                            </>
                                            :
                                            <RadioGroup row value={this.state.addData.Category} onChange={(e) => { this.handleInputChange(e, "Category") }} fullWidth>
                                                <FormControlLabel value="Major" control={<Radio color="default" />} label="Major" size="small" />
                                                <FormControlLabel value="Minor" control={<Radio color="default" />} label="Minor" size="small" />
                                            </RadioGroup>
                                        }
                                    </div>
                                    <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  px-0 "}`}>
                                        <label className={this.state.isMobile ? "d-flex mt-2" : "m-0 d-flex float-end text-right"}>Status&nbsp;:
                                            <div className={`${classes.helperText}`}>
                                                <div className="MuiFormHelperText-contained">*</div>
                                            </div></label>
                                    </div>

                                    <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-2" : "col-md-4 pt-4 pb-4"}`}>
                                        {this.state.Error.StatusError ?
                                            <>
                                                <RadioGroup row value={this.state.addData.Status} onChange={(e) => { this.handleInputChange(e, "Status") }} fullWidth className={classes.error}>
                                                    <FormControlLabel value="Open" control={<Radio color="default" className={classes.error} />} label="Open" size="small" />
                                                    <FormControlLabel value="Close" control={<Radio color="default" className={classes.error} />} label="Close" size="small" />
                                                </RadioGroup>
                                            </>
                                            :
                                            <RadioGroup row value={this.state.addData.Status} onChange={(e) => { this.handleInputChange(e, "Status") }} fullWidth>
                                                <FormControlLabel value="Open" control={<Radio color="default" />} label="Open" size="small" />
                                                <FormControlLabel value="Close" control={<Radio color="default" />} label="Close" size="small" />
                                            </RadioGroup>}
                                    </div>
                                </div>
                                <div className={`row mx-1 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>

                                    <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  px-0 mt-n2"}`}>
                                        <label className={this.state.isMobile ? "d-flex mt-2" : "m-0 d-flex float-end text-right"}>Observation&nbsp;:
                                            <div className={`${classes.helperText}`}>
                                                <div className="MuiFormHelperText-contained">*</div>
                                            </div></label>
                                    </div>
                                    <div className={`col-12 col-sm-12 col-lg-10 col-xl-11 ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1" : "col-md-10 pt-4"}`}>
                                        {this.state.Error.ObservationError ?
                                            <TextField
                                                multiline
                                                rows={4}
                                                variant="outlined"
                                                size="small"
                                                fullWidth
                                                error
                                                value={this.state.addData.Observation}
                                                onChange={(e) => { this.handleInputChange(e, "Observation") }}

                                                InputProps={{
                                                    className: `border-radius  ${classes.inputfieldAlign}`
                                                }}


                                            /> : <TextField
                                                multiline
                                                rows={4}
                                                variant="outlined"
                                                size="small"
                                                fullWidth
                                                value={this.state.addData.Observation}
                                                onChange={(e) => { this.handleInputChange(e, "Observation") }}

                                                InputProps={{
                                                    className: `border-radius  ${classes.inputfieldAlign}`
                                                }}
                                            />
                                        }
                                        <label className="float-end pt-2" style={{ opacity: '0.5' }}>{this.state.addData?.Observation?.length == undefined ? 500 - 0 : 500 - this.state.addData?.Observation?.length}/500 Characters left</label>

                                    </div>
                                </div>
                                <div className={`row mx-1 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>

                                    <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  px-0 "}`}>
                                        <label className={this.state.isMobile ? "d-flex mt-2" : "m-0 d-flex float-end text-right"}>Photo&nbsp;:
                                            <div className={`${classes.helperText}`}>
                                                <div className="MuiFormHelperText-contained">*</div>
                                            </div></label>
                                    </div>

                                    <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                        {this.state.Error.PhotoError ?
                                            <>
                                                <TextField
                                                    error
                                                    variant="outlined"
                                                    size="small"
                                                    style={{ borderColor: 'red' }}
                                                    fullWidth
                                                    placeholder="Browse File"
                                                    InputProps={{
                                                        endAdornment: (
                                                            <InputAdornment style={{ marginRight: 0 }}>
                                                                <IconButton className="rotate p-0" onClick={this.AttachFiles1}>
                                                                    <AttachFileIcon />
                                                                </IconButton>
                                                            </InputAdornment>
                                                        ),
                                                        className: `border-radius  ${classes.inputfieldAlign}`
                                                    }}

                                                />
                                                <input
                                                    type="file"
                                                    hidden
                                                    accept=".png,.jpg"
                                                    onChange={(e) => this.UploadFile(e)}
                                                    ref={this.inputPhoto}
                                                />
                                            </>
                                            :
                                            <>
                                                <TextField
                                                    disabled
                                                    variant="outlined"
                                                    size="small"
                                                    fullWidth
                                                    accept=".png,.jpg"
                                                    onChange={(e) => this.UploadFile(e)}
                                                    placeholder="Browse File"
                                                    InputProps={{
                                                        endAdornment: (
                                                            <InputAdornment style={{ marginRight: 0 }}>
                                                                <IconButton className="rotate p-0" onClick={this.AttachFiles1}>
                                                                    <AttachFileIcon />
                                                                </IconButton>
                                                            </InputAdornment>
                                                        ),
                                                        className: `border-radius  ${classes.inputfieldAlign}`
                                                    }}
                                                />
                                                <input
                                                    type="file"
                                                    hidden
                                                    accept=".png,.jpg"
                                                    onChange={(e) => this.UploadFile(e)}
                                                    ref={this.inputPhoto}
                                                />
                                            </>
                                        }
                                    </div>
                                    <div className={`col-12 col-sm-12 col-md-12 col-lg-6 col-xl-8 align-items-center ${this.state.isMobile ? "border-left border-right border-bottom col-md-12" : "mt-2"}`}>
                                        <div className={this.state.isMobile ? "row pl-2 pr-3" : "row px-1"}>
                                            {this.state.Photos.FileName == undefined ? <></> : <>
                                                <div
                                                    className={`col-12 col-sm-6 col-lg-6 col-xl-4 col-md-6 align-items-center px-1 mt-2 mb-2 ${window.innerWidth < 410
                                                            ? "col-12"
                                                            : this.state.isMobile
                                                                ? "col-md-4 "
                                                                : "col-md-6"
                                                        }`}
                                                >
                                                    <div className="row d-flex">
                                                        <div className="col-9 col-sm-9 col-lg-9 col-xl-9 col-md-9"></div>
                                                        <div className="col-3 col-sm-3 col-lg-3 col-xl-3 col-md-3 ">
                                                            <img
                                                                src={Delete}
                                                                className="cursorPointer"
                                                                onClick={() => { this.OpenPopup() }}

                                                            />
                                                        </div>
                                                        <div className="col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 pt-3 px-2">
                                                            <img
                                                                src={this.state.Photos.base64}
                                                                width={window.innerWidth < 290 ? "100%" : "257px"}
                                                                style={{
                                                                    height: "201px",
                                                                    marginTop: "-9px",
                                                                    objectPosition: "50% 50%",
                                                                }}
                                                                onClick={() => { this.openView(this.state.Photos.base64, this.state.Photos.FileName) }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* <div className={`col-6 col-sm-4 col-lg-6 col-xl-3 align-items-center  px-1 mt-1 mb-2 ${window.innerWidth < 410 ? "col-12" : this.state.isMobile ? "col-md-4 " : "col-md-6"}`}>
                                                    <div className="row d-flex">
                                                        <div className="col-2 col-sm-2 col-lg-2 col-xl-2 col-md-2 pt-1 mt-1" onClick={() => { this.openView(this.state.Photos.base64, this.state.Photos.FileName) }}>
                                                            <img
                                                                src={this.state.Photos.base64}
                                                                onClick={() => { this.openView(this.state.Photos.base64, this.state.Photos.FileName) }}
                                                                width={window.innerWidth < 290 ? "100%" : "257px"}
                                                                style={{
                                                                    height: "201px",
                                                                    marginTop: "-9px",
                                                                    objectPosition: "50% 50%",
                                                                }}
                                                            />
                                                        </div>
                                                        <div className="text-right col-2 col-sm-2 col-lg-2 col-xl-2 col-md-2 pl-1 pr-2 pt-1">
                                                            <img src={Delete} className="cursorPointer" onClick={() => { this.OpenPopup() }} />
                                                        </div>
                                                    </div>
                                                </div> */}
                                            </>}
                                        </div>
                                    </div>
                                </div>
                                <div className={`row mx-1 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>

                                    <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  px-0 mt-n3"}`}>
                                        <label className={this.state.isMobile ? "d-flex mt-2" : "m-0 d-flex float-end text-right"}>Corrective Action&nbsp;:
                                            <div className={`${classes.helperText}`}>
                                                <div className="MuiFormHelperText-contained">*</div>
                                            </div></label>
                                    </div>
                                    <div className={`col-12 col-sm-12 col-lg-10 col-xl-11   ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1" : "col-md-10 pt-4"}`}>
                                        {this.state.Error.CorrectiveActionError ?
                                            <TextField
                                                multiline
                                                rows={4}
                                                variant="outlined"
                                                size="small"
                                                fullWidth
                                                error
                                                value={this.state.addData.CorrectiveAction}
                                                onChange={(e) => { this.handleInputChange(e, "CorrectiveAction") }}

                                                InputProps={{
                                                    className: `border-radius  ${classes.inputfieldAlign}`
                                                }}


                                            /> : <TextField
                                                multiline
                                                rows={4}
                                                variant="outlined"
                                                size="small"
                                                value={this.state.addData.CorrectiveAction}
                                                onChange={(e) => { this.handleInputChange(e, "CorrectiveAction") }}

                                                fullWidth
                                                InputProps={{
                                                    className: `border-radius  ${classes.inputfieldAlign}`
                                                }}
                                            />
                                        }
                                        <label className="float-end pt-2" style={{ opacity: '0.5' }}>{this.state.addData?.CorrectiveAction?.length == undefined ? 500 - 0 : 500 - this.state.addData?.CorrectiveAction?.length}/500 Characters left</label>

                                    </div>
                                </div>
                                <div className={`row mx-1 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>

                                    <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  px-0 mt-n3"}`}>
                                        <label className={this.state.isMobile ? "d-flex mt-2" : "m-0 d-flex float-end text-right"}>Responsible Department&nbsp;:
                                            <div className={`${classes.helperText}`}>
                                                <div className="MuiFormHelperText-contained">*</div>
                                            </div></label>
                                    </div>

                                    <div className={`col-12 col-sm-12 col-lg-10 col-xl-11 ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1" : "col-md-10 pt-4"}`}>
                                        {this.state.Error.ResponsibleDepartmentError ?
                                            <TextField
                                                multiline
                                                rows={4}
                                                variant="outlined"
                                                size="small"
                                                fullWidth
                                                error
                                                value={this.state.addData.ResponsibleDepartment}
                                                onChange={(e) => { this.handleInputChange(e, "ResponsibleDepartment") }}

                                                InputProps={{
                                                    className: `border-radius  ${classes.inputfieldAlign}`
                                                }}


                                            /> : <TextField
                                                multiline
                                                rows={4}
                                                variant="outlined"
                                                size="small"
                                                value={this.state.addData.ResponsibleDepartment}
                                                onChange={(e) => { this.handleInputChange(e, "ResponsibleDepartment") }}

                                                fullWidth
                                                InputProps={{
                                                    className: `border-radius  ${classes.inputfieldAlign}`
                                                }}
                                            />
                                        }
                                        <label className="float-end pt-2" style={{ opacity: '0.5' }}>{this.state.addData?.ResponsibleDepartment?.length == undefined ? 500 - 0 : 500 - this.state.addData?.ResponsibleDepartment?.length}/500 Characters left</label>

                                    </div>

                                </div>
                                <div className={`row mx-1 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>

                                    <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  px-0 "}`}>
                                        <label className={this.state.isMobile ? "d-flex mt-2" : "m-0 d-flex float-end text-right"}>Target Date&nbsp;:
                                            <div className={`${classes.helperText}`}>
                                                <div className="MuiFormHelperText-contained">*</div>
                                            </div></label>
                                    </div>

                                    <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                        {this.state.Error.TargetDateError ?
                                            <TextField
                                                variant="outlined"
                                                size="small"
                                                fullWidth
                                                error
                                                type="date"
                                                id="type-date"
                                                value={this.state.addData.TargetDate && moment(this.state.addData.TargetDate).format("yyyy-MM-DD")}

                                                placeholder={this.state.addData.TargetDate && moment(this.state.addData.TargetDate).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                                onChange={(e) => { this.handleDateChange(e, "TargetDate") }}
                                                InputProps={{
                                                    className: `border-radius  ${classes.inputfieldAlign}`
                                                }}

                                            /> : <TextField
                                                variant="outlined"
                                                size="small"
                                                fullWidth
                                                value={this.state.addData.TargetDate && moment(this.state.addData.TargetDate).format("yyyy-MM-DD")}
                                                placeholder={this.state.addData.TargetDate && moment(this.state.addData.TargetDate).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                                onChange={(e) => { this.handleDateChange(e, "TargetDate") }}
                                                type="date"
                                                id="type-date"
                                                InputProps={{
                                                    className: `border-radius  ${classes.inputfieldAlign}`
                                                }}
                                            />
                                        }
                                    </div>
                                    <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  px-0 text-right"}`}>
                                        <label className={this.state.isMobile ? "mt-2" : "m-0 d-flex text-right float-end"}>Completion Date&nbsp;:</label>
                                    </div>

                                    <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            value={this.state.addData.CompletionDate && moment(this.state.addData.CompletionDate).format("yyyy-MM-DD")}
                                            placeholder={this.state.addData.CompletionDate && moment(this.state.addData.CompletionDate).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                            onChange={(e) => { this.handleDateChange(e, "CompletionDate") }}
                                            type="date"
                                            id="type-date"
                                            InputProps={{
                                                className: `border-radius  ${classes.inputfieldAlign}`
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className={`row mx-1 ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                    <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2 mt-4 px-0 text-right"}`}>
                                        <label className={this.state.isMobile ? " mt-2" : "m-0 d-flex text-right float-end"}>Completion Photos&nbsp;:</label>
                                    </div>
                                    <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right  col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                        <TextField
                                            disabled
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            accept=".png,.jpg"
                                            onChange={(e) => this.UploadFile1(e)}
                                            placeholder="Browse File"
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment style={{ marginRight: 0 }}>
                                                        <IconButton className="rotate p-0" onClick={this.AttachFiles}>
                                                            <AttachFileIcon />
                                                        </IconButton>
                                                    </InputAdornment>
                                                ),
                                                className: `border-radius  ${classes.inputfieldAlign}`
                                            }}
                                        />
                                        <input
                                            type="file"
                                            hidden
                                            accept=".png,.jpg"
                                            onChange={(e) => this.UploadFile1(e)}
                                            multiple="multiple"
                                            ref={this.inputCPhoto}
                                        />
                                    </div>
                                    <div className="col-12 col-sm-12 col-lg-6 col-xl-8"></div>
                                    <div className="row mx-0 px-0">
                                        <div
                                            className={`col-12 col-sm-12  col-md-12 col-lg-12 col-xl-12 align-items-center ${this.state.isMobile
                                                ? "border-left border-right border-bottom col-md-12"
                                                : "mt-2 "
                                                }`}
                                        >
                                            <div
                                                className={
                                                    this.state.isMobile ? "row pl-2 pr-3" : "row px-1"
                                                }
                                            >
                                                {this.state.CPhotos && this.state.CPhotos.map((i, ind) => {
                                                    return (
                                                        <div
                                                            className={`col-12 col-sm-6 col-lg-6 col-xl-4 col-md-6 align-items-center px-1 mt-2 mb-2 ${window.innerWidth < 410
                                                                ? "col-12"
                                                                : this.state.isMobile
                                                                    ? "col-md-4 "
                                                                    : "col-md-6"
                                                                }`}
                                                        >
                                                            <div className="row d-flex">
                                                                <div className="col-9 col-sm-9 col-lg-9 col-xl-9 col-md-9"></div>
                                                                <div className="col-3 col-sm-3 col-lg-3 col-xl-3 col-md-3 ">
                                                                    <img
                                                                        src={Delete}
                                                                        className="cursorPointer"
                                                                        onClick={() => { this.OpenPopup1(ind) }}
                                                                    />
                                                                </div>
                                                                <div className="col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 pt-3 px-2">
                                                                    <img
                                                                        src={i.base64}
                                                                        width={window.innerWidth < 290 ? "100%" : "257px"}
                                                                        style={{
                                                                            height: "201px",
                                                                            marginTop: "-9px",
                                                                            objectPosition: "50% 50%",
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className={`col-12 col-sm-12 col-md-12 col-lg-6 col-xl-8 align-items-center ${this.state.isMobile ? "border-left border-right border-bottom col-md-12" : "mt-2"}`}>
                                        <div className={this.state.isMobile ? "row pl-2 pr-3" : "row px-1"}>
                                            {this.state.CPhotos && this.state.CPhotos.map((i, ind) => (
                                                <div className={`col-6 col-sm-4 col-lg-6 col-xl-3 align-items-center border-right  px-1 mt-1 mb-2 ${window.innerWidth < 410 ? "col-12" : this.state.isMobile ? "col-md-4 " : "col-md-6"}`}>
                                                    <div className="row d-flex">
                                                        <div className="col-2 col-sm-2 col-lg-2 col-xl-2 col-md-2 pt-1 mt-3" onClick={() => { this.openView(i.base64, i.FileName) }}>
                                                            <img className="cursorPointer" src={i.base64} onClick={() => { this.openView(i.base64, i.FileName) }} style={{ width: '40px', height: '36px', marginTop: '-9px' }} />
                                                        </div>
                                                        <div className="col-8 col-sm-8 col-lg-8 col-xl-8 col-md-8">
                                                            <div onClick={() => { this.openView(i.base64, i.FileName) }} className="cursorPointer pt-2 ml-3 overflow">{i.FileName}<br></br><label style={{ color: "#B0AAAA", fontSize: '10px' }}>{(i.Filesize / 1048576).toFixed(2)}&nbsp;MB</label></div>
                                                        </div>
                                                        <div className="col-2 col-sm-2 col-lg-2 col-xl-2 col-md-2 pl-1 pr-2 mt-2 pt-2">
                                                            <img src={Delete} className="cursorPointer" onClick={() => { this.OpenPopup1(ind) }} />
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div> */}
                                </div>
                            </> :
                                <>
                                    <div className={`row mt-2 mx-1 align-items-center ${this.state.isMobile ? "" : "text-row"}`}>
                                        <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-top border-right col-md-12" : "col-md-2  px-0 text-right"}`}>
                                            <label className={this.state.isMobile ? "d-flex mt-2" : "m-0 d-flex float-end text-right"}>Total Findings&nbsp;:
                                                <div className={`${classes.helperText}`}>
                                                    <div className="MuiFormHelperText-contained">*</div>
                                                </div></label>
                                        </div>
                                        <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                            {this.state.Error.TotalFindingsError ?
                                                <TextField
                                                    variant="outlined"
                                                    size="small"
                                                    fullWidth
                                                    error
                                                    type="number"
                                                    value={this.state.Initial.TotalFindings}
                                                    onChange={(e) => { this.handleNumberChange(e, "TotalFindings") }}
                                                    InputProps={{
                                                        className: `border-radius  ${classes.inputfieldAlign}`
                                                    }}
                                                /> : <TextField
                                                    variant="outlined"
                                                    size="small"
                                                    fullWidth
                                                    value={this.state.Initial.TotalFindings}
                                                    onChange={(e) => { this.handleNumberChange(e, "TotalFindings") }}

                                                    type="number"
                                                    InputProps={{
                                                        className: `border-radius  ${classes.inputfieldAlign}`
                                                    }}
                                                />
                                            }
                                        </div>
                                        <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  px-0 text-right"}`}>
                                            <label className={this.state.isMobile ? "d-flex mt-2" : "m-0 d-flex float-end text-right"}>Total Minor&nbsp;:
                                                <div className={`${classes.helperText}`}>
                                                    <div className="MuiFormHelperText-contained">*</div>
                                                </div></label>
                                        </div>
                                        <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                            {this.state.Error.TotalMinorError ?
                                                <TextField
                                                    variant="outlined"
                                                    size="small"
                                                    fullWidth
                                                    error
                                                    type="number"
                                                    value={this.state.Initial.TotalMinor}
                                                    onChange={(e) => { this.handleNumberChange(e, "TotalMinor") }}
                                                    InputProps={{
                                                        className: `border-radius  ${classes.inputfieldAlign}`
                                                    }}
                                                /> : <TextField
                                                    variant="outlined"
                                                    size="small"
                                                    fullWidth
                                                    type="number"
                                                    value={this.state.Initial.TotalMinor}
                                                    onChange={(e) => { this.handleNumberChange(e, "TotalMinor") }}
                                                    InputProps={{
                                                        className: `border-radius  ${classes.inputfieldAlign}`
                                                    }}
                                                />
                                            }
                                        </div>
                                        <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  px-0 text-right"}`}>
                                            <label className={this.state.isMobile ? "d-flex mt-2" : "m-0 d-flex float-end text-right"} >Total Major&nbsp;:
                                                <div className={`${classes.helperText}`}>
                                                    <div className="MuiFormHelperText-contained">*</div>
                                                </div></label>
                                        </div>
                                        <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                            {this.state.Error.TotalMajorError ?
                                                <TextField
                                                    variant="outlined"
                                                    size="small"
                                                    fullWidth
                                                    error
                                                    type="number"
                                                    value={this.state.Initial.TotalMajor}
                                                    onChange={(e) => { this.handleNumberChange(e, "TotalMajor") }}
                                                    InputProps={{
                                                        className: `border-radius  ${classes.inputfieldAlign}`
                                                    }}
                                                /> : <TextField
                                                    variant="outlined"
                                                    size="small"
                                                    fullWidth
                                                    type="number"
                                                    value={this.state.Initial.TotalMajor}
                                                    onChange={(e) => { this.handleNumberChange(e, "TotalMajor") }}
                                                    InputProps={{
                                                        className: `border-radius  ${classes.inputfieldAlign}`
                                                    }}
                                                />
                                            }
                                        </div>
                                    </div>
                                    <div className={`row mx-1 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                        <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2 text-right"}`}>
                                            <label className={this.state.isMobile ? " mt-2" : "m-0 d-flex float-end text-right"}>No.Of Findings Closed&nbsp;:</label>
                                        </div>
                                        <div className={`col-12 col-sm-12 pb-4  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1" : "col-md-4 pt-4"}`}>
                                            <TextField
                                                variant="outlined"
                                                size="small"
                                                fullWidth
                                                type="number"
                                                disabled
                                                value={this.state.Initial.NoofFindingsClose}
                                                InputProps={{
                                                    className: `border-radius view-color ${classes.inputfieldAlign}`
                                                }}
                                            />
                                        </div>
                                        <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  px-0 text-right"}`}>
                                            <label className={this.state.isMobile ? "d-flex mt-2" : "m-0 d-flex float-end text-right"}>Minor&nbsp;:
                                                <div className={`${classes.helperText}`}>
                                                    <div className="MuiFormHelperText-contained">*</div>
                                                </div></label>
                                        </div>
                                        <div className={`col-12 col-sm-12 pb-4  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1" : "col-md-4 pt-4"}`}>
                                            {this.state.Error.MinorCloseError ?
                                                <TextField
                                                    variant="outlined"
                                                    size="small"
                                                    fullWidth
                                                    error
                                                    type="number"
                                                    value={this.state.Initial.MinorClose}
                                                    onChange={(e) => { this.handleNumberChange(e, "MinorClose") }}
                                                    InputProps={{
                                                        className: `border-radius  ${classes.inputfieldAlign}`
                                                    }}

                                                /> :
                                                <TextField
                                                    variant="outlined"
                                                    size="small"
                                                    fullWidth
                                                    type="number"
                                                    value={this.state.Initial.MinorClose}
                                                    onChange={(e) => { this.handleNumberChange(e, "MinorClose") }}
                                                    InputProps={{
                                                        className: `border-radius  ${classes.inputfieldAlign}`
                                                    }}
                                                />
                                            }
                                        </div>
                                        <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  px-0 text-right"}`}>
                                            <label className={this.state.isMobile ? "d-flex mt-2" : "m-0 d-flex float-end text-right"}>Major&nbsp;:
                                                <div className={`${classes.helperText}`}>
                                                    <div className="MuiFormHelperText-contained">*</div>
                                                </div></label>
                                        </div>
                                        <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                            {this.state.Error.MajorCloseError ?
                                                <TextField
                                                    variant="outlined"
                                                    size="small"
                                                    fullWidth
                                                    error
                                                    type="number"
                                                    value={this.state.Initial.MajorClose}
                                                    onChange={(e) => { this.handleNumberChange(e, "MajorClose") }}
                                                    InputProps={{
                                                        className: `border-radius  ${classes.inputfieldAlign}`
                                                    }}
                                                /> : <TextField
                                                    variant="outlined"
                                                    size="small"
                                                    fullWidth
                                                    type="number"
                                                    value={this.state.Initial.MajorClose}
                                                    onChange={(e) => { this.handleNumberChange(e, "MajorClose") }}
                                                    InputProps={{
                                                        className: `border-radius  ${classes.inputfieldAlign}`
                                                    }}
                                                />
                                            }
                                        </div>
                                    </div>
                                    <div className={`row mx-1 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                        <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  text-right"}`}>
                                            <label className={this.state.isMobile ? " mt-2" : "float-end m-0 text-right"}>No.Of Findings Open&nbsp;:</label>
                                        </div>
                                        <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                            <TextField
                                                variant="outlined"
                                                size="small"
                                                fullWidth
                                                disabled
                                                type="number"
                                                value={this.state.Initial.NoofFindingsOpen}
                                                InputProps={{
                                                    className: `border-radius view-color ${classes.inputfieldAlign}`
                                                }}
                                            />
                                        </div>
                                        <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  text-right"}`}>
                                            <label className={this.state.isMobile ? " mt-2" : "m-0 d-flex float-end text-right"}>Minor&nbsp;:</label>
                                        </div>
                                        <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                            <TextField
                                                variant="outlined"
                                                size="small"
                                                fullWidth
                                                type="number"
                                                value={this.state.Initial.MinorOpen}
                                                disabled
                                                InputProps={{
                                                    className: `border-radius view-color ${classes.inputfieldAlign}`
                                                }}
                                            />
                                        </div>
                                        <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right col-md-12" : "col-md-2  text-right"}`}>
                                            <label className={this.state.isMobile ? " mt-2" : "m-0 d-flex float-end text-right"}>Major&nbsp;:</label>
                                        </div>
                                        <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                            <TextField
                                                variant="outlined"
                                                size="small"
                                                disabled
                                                fullWidth
                                                value={this.state.Initial.MajorOpen}
                                                type="number"
                                                InputProps={{
                                                    className: `border-radius view-color ${classes.inputfieldAlign}`
                                                }}
                                            />

                                        </div>
                                    </div>
                                    <div className={this.state.isMobile ? "fw-bold mt-2 px-3" : "fw-bold mt-2 px-1"}>
                                        Note: For more details, kindly refer "Audit & Corrective Action" report in the Yard documents.
                                    </div>
                                </>
                            }
                        </div>
                    </div>
                    <div class="modal fade p-5 mt-5" id="deletepopup" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">Are you sure you want to delete?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" data-dismiss="modal" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} style={{ backgroundColor: "#00838F", border: "none" }} onClick={() => this.DeleteItem()}><span className="" >Delete</span></button>
                                    <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#deletepopup").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade p-5 mt-5" id="deletepopup1" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">Are you sure you want to delete?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" data-dismiss="modal" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} style={{ backgroundColor: "#00838F", border: "none" }} onClick={() => this.DeleteItem1()}><span className="" >Delete</span></button>
                                    <button type="button" id="closemodal" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#deletepopup1").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade p-5 mt-5" id="cancelpopup1" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">The data will be lost. Do you really want to cancel?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.SideBarCancel}><span className="" >Yes</span></button>
                                    <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#cancelpopup1").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade p-5 mt-5" id="cancelpopup" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">The data will be lost. Do you really want to cancel?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.AddCancel}><span className="" >Yes</span></button>
                                    <button type="button" id="closemodal2" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#cancelpopup").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        LocationLookUp: state.MasterDataReducer.Lookup_data || [],
        settings: state.commonReducer.settings || [],
        // projectList: state.projectReducer.projectList || [],
        // projectNames: state.projectReducer.projectNames || [],
    };
}

AddIADOS.propTypes = {
    classes: PropTypes.object.isRequired,
}
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AddIADOS))
);

